import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import App from "./App";

import * as serviceWorker from "./serviceWorker";
import { SettingsProvider } from "@hubcapp/context";
import { restoreSettings } from "@ds-developer/frontend";

const settings = restoreSettings();

ReactDOM.render(
  <React.StrictMode>
    <SettingsProvider settings={settings}>
      <App />
    </SettingsProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
